import { render, staticRenderFns } from "./BackgroundTaskProgress.vue?vue&type=template&id=2d9b24ce&"
import script from "./BackgroundTaskProgress.vue?vue&type=script&lang=js&"
export * from "./BackgroundTaskProgress.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundTaskProgress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports